/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API56370Req {
  
  /** 业务编号 */
  bizNo?: string;
  /** 业务类型：1.项目2.业务 */
  bizType?: number;
  /** 数据目标 */
  dataTarget?: number;
  /** 业务指标：1.gmv指标 */
  businessIndicator?: number;
  /** 业务指标类型：1.gmv退款后 */
  businessIndicatorType?: number;
  /** 指标对象 ,List */
  indicatorObject?: any[];
  /** 指标开始时间 */
  indicatorDateStart?: any;
  /** 指标结束时间 */
  indicatorDateEnd?: any;
};



export type API56370Res = {};


// 56370 保存指标

export interface IUsePostAPI56370Return {
  /** 保存指标: 接口请求状态 */
  isAPI56370Loading: boolean;
  /** 保存指标: 接口请求返回数据 */
  dataAPI56370: API56370Res;
  /**  保存指标: 接口数据请求方法 */
  fetchAPI56370Data:  (inputs: API56370Req, config?: YWRequestConfig) => Promise<API56370Res>;
  /** 保存指标: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI56370 = ():IUsePostAPI56370Return => {
  let isMount = true;
  const [isAPI56370Loading, setIsAPI56370Loading] = useState(false);
  const [dataAPI56370, setDataAPI56370] = useState<API56370Res>({} as API56370Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/indicator/save`;

  const fetchAPI56370Data = async (inputs: API56370Req, config?: YWRequestConfig): Promise<API56370Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API56370Req>) || {}) as API56370Req;
    
  
    if ( isMount ) {
      setIsAPI56370Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API56370Res>(`${basePath}/corp-admin/project/plan/task/indicator/save`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI56370(res || {} as API56370Res);
        setIsAPI56370Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI56370Loading(false);
      }
      return false as unknown as API56370Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI56370Loading,
    dataAPI56370,
    fetchAPI56370Data,
    requestUrl,
  }
}

